export default {
  retailerId: "Customer",
  billingLocation: "Bill To",
  shippingLocationId: "Ship To",
  purchaseOrder: "PO #",
  status: "Status",
  email: "Email",
  transactionType: "Transaction Type",
  sourceId: "Order Source",
  paymentTermsId: "Terms",
  priceList: "Price List",
  vendorId: "Vendor",
  buyer: "Contact/Buyer",
  shippingMethodId: "Ship Via",
  shipOn: "Ship Date",
  cancelOn: "Cancel Date",
  invoiceDate: "Invoice Date",
  dueDate: "Due Date",
  orderedOn: "Order Date",
  companyName: "Name",
  note: "Note",
  vendorNote: false,
  deliveryNote: false,
  shippingNote: false,
  tagFor: false,
  cartName: "Order Name",
  status: "Status",
  transactionType: "Type",
  discount: "Discount",
  invoiceNumber: "Invoice #",
  orderNumber: "Order #",
  warehouse: false,
  container: false,
  division: false,
  bol: false,
  shippingMethodId: false,
  lineCount: "Total Lines",
  qtyOrdered: "Total Qty",
  qtyShipped: "Total Shipped",
  weight: "Total Weight",
  cubicVolume: "Cubic Ft",
  totalOrder: "Order Total", //curOrderTotal
  additionalCharges: "Additional Charges", //strCustom15
  taxCharges: "Tax", //strCustom14
  totalOrderAmount: false, // "fltTotalOrderAmount",
  totalShipped: "Subtotal", //"Shipped",
  totalDiscount: false, //"Discount",
  totalFreight: "Freight",
  invoiceTotal: "Total", //fltInvoiceAmount
  invoiceBalance: "Balance", //curBalance
  //credit memo
  cmAmount: false,
  reason: false,
  description: false,
  // line
  availableOn: false,
  lineNote: "Note",
  lineDiscount: "Discount (%)",
  lineVendorId: false,
  reasonCode: "Reason Code",
  SaveOrderLabel: "Save",
  SavingOrderLabel: "Saving...",
  // icons
  prevInvoice: false,
  nextInvoice: false,
};
